module.exports = __webpack_public_path__ + "img/login-page_2.d9ccbe13.png";